module.exports = __webpack_public_path__ + "static/media/045-exclamation mark.d24d5cf1.svg";